import React from "react";

function Header() {
  return (
    <header>
      <h1>TASKMASTER v2</h1>
    </header>
  );
}

export default Header;
